/** API route map: URLS.Controller.EmployeeBank */
export const EmployeeBank = {
      Name: 'EmployeeBank/',
      GetAll: 'employee-bank-detail',
      AddEmployeeBank: 'add-employee-bank',
      UpdateEmployeeBank: 'update',
      DeleteEmployeeBank: 'delete/',
      CheckEmployeeBank: 'check-employee-bank/',
      MarkAsPrimary: 'mark-as-primary/',
      GetAllBankAccounts: 'get-all-bank-accounts',
      GetAllEmployeeAccounts: 'get-all-employee-bank-list',
      SubmitChangeRequest: 'submit-bank-detail-change-request',
      GetPendingRecords: 'employee-bank-detail-pending-records',
};
